import api, { IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { AProvider } from "src/framework/providers/AProvider";
import { ContaType, EquipeType, ExtraInfoUsuario } from "./types";

class ContaProvider extends AProvider {
    constructor() {
        super("/cadastros/contas");
    }

    async fetchDistribuidores(): Promise<ContaType[]> {
        const request: IDataRequest = { url: `${this.path}/?tipo_conta_in=1,2` }
        const response: IDataResponse = await api.get(request);
        if (response.statusCode === STATUS_CODE.OK) {
            return response.data?.rows.shit() || response.data
        }
        return [];
    }

    async getDistribuidorRevendaUsuario(): Promise<ExtraInfoUsuario | null> {
        return null;
        // const request: IDataRequest = { url: `${this.path}/usuario` }

        // const response: IDataResponse = await api.get(request);

        // if (response.statusCode === STATUS_CODE.OK) {
        //     return response.data?.rows || response.data
        // }

        // return null
    }

    async getEquipe(codigoDistribuidorRevenda: number, tipoVinculos: "vertical_ongrid" | "vertical_offgrid" | "distribuicao_ongrid" | "distribuicao_offgrid"): Promise<EquipeType | null> {


        const request: IDataRequest = {
            url: `${this.path}/equipe/${codigoDistribuidorRevenda}/${tipoVinculos}`
        }

        const response: IDataResponse = await api.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            return data;
        }

        return null;
    }
}

export { ContaProvider }